export default __webpack_public_path__ + "static/media/unia.558c074a.png";